module.exports = __webpack_public_path__ + "img/Timor-Leste.2af0c1c3.svg";